module.exports = "<div class=additional-services-view> <div class=additional-services-target> </div> <div class=\"no-services-added q-alert q-alert-grey q-marg-vert-lg\"> No added service. If desired, please select a service above. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/ServicesTab/html/additionalServicesView.html
// module id = 1218
// module chunks = 1